<div class="background">
  <h3 mat-dialog-title>Edit {{ data.field }} of {{ data.property }}:</h3>
  @if (data.field === "Client Identifier") {
  <form [formGroup]="form2">
    <mat-form-field class="full-width">
      <input
        formControlName="clientTag"
        matInput
        placeholder="ac2"
        (keydown.enter)="enterEditClientTag()"
      />
      @if (form2.get('clientTag')!.hasError('clientTagAlreadyExists')) {
      <mat-error> Client tag is not available </mat-error>
      } @if (form2.get('clientTag')!.hasError('required') ||
      form2.get('clientTag')!.hasError('pattern')) {
      <mat-error> Please enter a valid client tag. </mat-error>
      }
      <mat-hint
        >A tag of letters and numbers. (maximum length of 10 characters)
      </mat-hint>
    </mat-form-field>
  </form>
  } @else if (this.data.property == "Version" && this.data.field === "Name") {
  <form [formGroup]="form">
    <mat-form-field class="full-width">
      <input
        formControlName="name"
        matInput
        placeholder="1.0"
        (keydown.enter)="enterEditVersionName()"
      />
      @if (form.get('name')!.hasError('nameAlreadyExists')) {
      <mat-error> Version name is not available </mat-error>
      } @if (form.get('name')!.hasError('required')) {
      <mat-error> Please enter a valid version name. </mat-error>
      }
    </mat-form-field>
  </form>
  } @else {
  <mat-form-field class="full-width">
    <mat-label>{{ data.field }}</mat-label>
    <input (keydown.enter)="enterEdit()" [(ngModel)]="inputValue" matInput />
  </mat-form-field>
  }

  <mat-card
    class="edited-card"
    [ngClass]="{
      'status-edited': (editedValue$ | async) === true,
      'status-failed': (editedValue$ | async) === false,
      'status-not-edited': !editPressed
    }"
  >
    <p *ngIf="!editPressed">Press Save to submit your change.</p>
    @if (editPressed) {
    <p *ngIf="(editedValue$ | async) === null">Editing...</p>
    <p *ngIf="(editedValue$ | async) === true">Your Change has been made.</p>
    <p *ngIf="(editedValue$ | async) === false">
      Your Change could not be made.
    </p>
    }
  </mat-card>

  <div [align]="'end'" mat-dialog-actions>
    <button [mat-dialog-close]="false" mat-raised-button>Cancel</button>
    <button
      (click)="editValue()"
      color="primary"
      mat-raised-button
      [disabled]="
        (data.field === 'Client Tag'
          ? form2.get('clientTag')?.hasError('required') ||
            form2.get('clientTag')!.hasError('pattern') ||
            form2.get('clientTag')!.hasError('clientTagAlreadyExists')
          : this.data.property == 'Version' && this.data.field === 'Name'
          ? form.get('name')!.hasError('nameAlreadyExists') ||
            form.get('name')!.hasError('required')
          : inputValue === data.value) || editPressed
      "
    >
      Save
    </button>
  </div>
</div>
